import {
  TbBarrel,
  TbBug,
  TbBuildingFactory2,
  TbBuildingWarehouse,
  TbCalendarEvent,
  TbChartBar,
  TbClipboardList,
  TbCylinder,
  TbHistory,
  TbHome,
  TbSpeakerphone,
} from "react-icons/tb";
import { ACCOUNTS, PERMISSIONS } from "../../routeAccess";

// Declarative menu of the app shell. One entry per link, in display order.
//   path        route the link opens
//   labelKey    label key (resolved by the shell)
//   icon        react-icons component
//   section     'primary' | 'secondary' sidebar block
//   audience    'admin' (platform ADMIN only) | 'tenant' (every other account)
//   permission  tenant entries only. [resource, action] or [[resource, action], ...] (any-of).
//               Absent: always visible to the audience. Read actions use the EXPLICIT read (canSee: an
//               implied read opens no menu entry), any other action the effective one (can).
//   accounts    tenant entries only, optional. Account types (ROLES) the route lets in, the ACCOUNTS group the
//               route of the entry uses in App.js. Absent: any tenant account.
//   activePath, exact  optional, passed to the shell link as they are.
// Permission pairs come from routeAccess.js, so an entry follows the guard of the route it opens.
// /alerts stays out on purpose: the page is not exposed in the menu yet.
export const SIDEBAR_ITEMS = [
  { path: "/clients", labelKey: "homeNavLink", icon: TbHome, section: "primary", audience: "admin", activePath: "/", exact: true },
  { path: "/", labelKey: "homeNavLink", icon: TbHome, section: "primary", audience: "tenant", activePath: "/", exact: true },
  { path: "/admin/error-reports", labelKey: "errorReportsNavLink", icon: TbBug, section: "primary", audience: "admin" },
  { path: "/admin/announcements", labelKey: "announcementsNavLink", icon: TbSpeakerphone, section: "primary", audience: "admin" },
  { path: "/admin/changelog", labelKey: "changelogAdminNavLink", icon: TbHistory, section: "primary", audience: "admin" },
  { path: "/programming", labelKey: "programmingNavLink", icon: TbCalendarEvent, section: "primary", audience: "tenant", accounts: ACCOUNTS.winery, permission: PERMISSIONS.operationsRead },
  { path: "/lots", labelKey: "lotsNavLink", icon: TbBarrel, section: "primary", audience: "tenant", accounts: ACCOUNTS.winery, permission: PERMISSIONS.lotsRead },
  { path: "/tanks", labelKey: "tanksNavLink", icon: TbCylinder, section: "primary", audience: "tenant", accounts: ACCOUNTS.winery, permission: PERMISSIONS.tanksRead },
  { path: "/protocols", labelKey: "protocolsNavLink", icon: TbClipboardList, section: "primary", audience: "tenant", accounts: ACCOUNTS.winery, permission: PERMISSIONS.protocolsList },
  // { path: "/alerts", labelKey: "eventAlertsMenu", icon: TbChartBar, section: "primary", audience: "tenant", permission: PERMISSIONS.alertsRead },
  { path: "/warehouse", labelKey: "warehouseNavLink", icon: TbBuildingWarehouse, section: "secondary", audience: "tenant", accounts: ACCOUNTS.people, permission: PERMISSIONS.warehouseRead },
  { path: "/report", labelKey: "reportNavLink", icon: TbChartBar, section: "secondary", audience: "tenant", accounts: ACCOUNTS.people, permission: PERMISSIONS.reportsExport },
  { path: "/wineries", labelKey: "wineriesNavLink", icon: TbBuildingFactory2, section: "secondary", audience: "tenant", accounts: ACCOUNTS.winery, permission: PERMISSIONS.wineriesRead },
];

const pairsOf = (permission) => (Array.isArray(permission[0]) ? permission : [permission]);

const isPermitted = (permission, { canSee, can }) =>
  pairsOf(permission).some(([resource, action]) =>
    String(action).toLowerCase() === "read" ? canSee(resource) : can(resource, action)
  );

// Items the current account sees, in the order of the config. The platform ADMIN gets the admin
// entries only; every other account the tenant entries whose permission it holds.
// `role` is the account type of the session (the token role, as the route guards read it): an entry
// with `accounts` is shown only to those, so a visible entry never leads to /unauthorized.
export const visibleSidebarItems = (items, { isAdmin, role, canSee, can }) =>
  items.filter((item) => {
    if (isAdmin) return item.audience === "admin";
    if (item.audience !== "tenant") return false;
    if (item.accounts && !item.accounts.some((account) => Number(account) === Number(role))) return false;
    return !item.permission || isPermitted(item.permission, { canSee, can });
  });
